import { render, staticRenderFns } from "./ClientRecordEntries.vue?vue&type=template&id=83357092&scoped=true"
import script from "./ClientRecordEntries.vue?vue&type=script&lang=js"
export * from "./ClientRecordEntries.vue?vue&type=script&lang=js"
import style0 from "./ClientRecordEntries.vue?vue&type=style&index=0&id=83357092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83357092",
  null
  
)

export default component.exports